import axios from 'axios';
import AuthService from './AuthService';

const API_BASE = process.env.REACT_APP_API_URL;

// Helper function to get auth headers
async function getAuthHeaders() {
  const authService = new AuthService();
  const token = await authService.getAccessToken();
  
  if (!token) {
    throw new Error("No access token available");
  }
  
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
}

export interface UserStats {
  userId: string;
  totalMappingSessions: number;
  totalAnnotations: number;
  totalABCDEAssessments: number;
  totalSegmentationAnalyses: number;
  lastActivity: string;
  patientsCount: number;
  averageAssessmentScore: number;
  highRiskFindings: number;
}

export interface RecentActivity {
  type: 'mapping' | 'annotation' | 'abcde' | 'segmentation';
  description: string;
  timestamp: string;
  patientId?: string;
}

export interface WeeklyProgress {
  week: string;
  mappingSessions: number;
  annotations: number;
  abcdeAssessments: number;
}

export interface DashboardStats {
  userStats: UserStats;
  recentActivity: Array<RecentActivity>;
  weeklyProgress: Array<WeeklyProgress>;
}

export async function getDashboardStats(): Promise<DashboardStats> {
  try {
    const headers = await getAuthHeaders();
    const response = await axios.get(`${API_BASE}/dashboard/stats`, { headers });
    return response.data;
  } catch (error: any) {
    console.error('Error fetching dashboard stats:', error);
    // Return mock data for development if API fails
    return {
      userStats: {
        userId: 'current-user',
        totalMappingSessions: 0,
        totalAnnotations: 0,
        totalABCDEAssessments: 0,
        totalSegmentationAnalyses: 0,
        lastActivity: new Date().toISOString(),
        patientsCount: 0,
        averageAssessmentScore: 0,
        highRiskFindings: 0
      },
      recentActivity: [],
      weeklyProgress: []
    };
  }
}
